import React from 'react';
import cn from 'classnames';

import { Icon } from 'components/shared/Icon';

import styles from './CompletedIcon.module.scss';

const CompletedIcon = ({ className }: { className: any }) => (
  <div className={cn(styles.wrapper, className)}>
    <Icon name="check" className={styles.icon} />
  </div>
);

export default React.memo(CompletedIcon) as any;
